import type { AuthOutboundHttpPort } from '../../domain/ports/AuthOutboundHttpPort.ts';
import { AuthService } from '../../application/AuthService.ts';
import type { AuthProviderPort } from '../../domain/ports/AuthProviderPort.ts';
import type { AuthTokenStoragePort } from '../../domain/ports/AuthTokenStoragePort.ts';
import { ApiAuthAdapter } from '../driven/ApiAuthAdapter.ts';
import type { GetLocalSqliteDatabase, LocalSqliteHealthQuery } from '../driven/LocalSqlAuthAdapter.ts';
import { LocalSqlAuthAdapter } from '../driven/LocalSqlAuthAdapter.ts';

const defaultLocalSqlite: GetLocalSqliteDatabase = () => undefined;

/** Builds the authentication provider based on the environment (offline or API). */
function buildAuthProvider(
  tokenStorage: AuthTokenStoragePort,
  http: AuthOutboundHttpPort | null,
  offlineSqlite: boolean,
  getLocalSqlite?: GetLocalSqliteDatabase,
  getSqliteHealth?: LocalSqliteHealthQuery,
): AuthProviderPort {
  if (offlineSqlite) {
    return new LocalSqlAuthAdapter(
      tokenStorage,
      getLocalSqlite ?? defaultLocalSqlite,
      getSqliteHealth,
    );
  }
  if (!http) throw new Error('HttpClient requerido sin SQLite local.');
  return new ApiAuthAdapter(http, tokenStorage);
}

/** Creates the authentication application service. */
export function createAuthApplicationService(
  tokenStorage: AuthTokenStoragePort,
  http: AuthOutboundHttpPort | null,
  offlineSqlite: boolean,
  getLocalSqlite?: GetLocalSqliteDatabase,
  getSqliteHealth?: LocalSqliteHealthQuery,
): AuthService {
  return new AuthService(
    buildAuthProvider(tokenStorage, http, offlineSqlite, getLocalSqlite, getSqliteHealth),
    tokenStorage,
  );
}
